export default "<div class=\"qrcode flex items-center justify-center\" #qrcodeImg [ngClass]=\"{'page-style': promoCode}\"></div>\n";